<template>
    <Select
        v-model="reactiveValue"
        v-bind="$attrs"
        filterable
        transfer
        v-on="$listeners"
    >
        <Option v-if="isSearch" value="-1">全部</Option>
        <Option
            v-for="(item, index) in dictList"
            :key="index"
            :value="item.value"
            >{{ item.name }}</Option
        >
    </Select>
</template>

<script>
import { isNotEmpty } from '../utils/func';

export default {
    name: 'DictSelect',
    props: {
        dict: {
            type: String,
        },
        isSearch: {
            type: Boolean,
            default: false,
        },
        value: {
            type: [String, Array],
            default: null,
        },
        // 增加一个全部
        useAllType: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        dictList() {
            if (this.dict === 'switch') {
                return [
                    {
                        code: 'all',
                        value: '-1',
                        name: '全部',
                    },
                    {
                        code: 'true',
                        value: '1',
                        name: '是',
                    },
                    {
                        code: 'false',
                        value: '0',
                        name: '否',
                    },
                ];
            }
            const list =
                this.$comon.$dict(this.dict).filter((item) => item.status) ||
                [];
            if (this.useAllType) {
                list.unshift({
                    code: 'all',
                    value: '-1',
                    name: '全部',
                });
            }
            if (isNotEmpty(this.dict)) return list;
            return [];
        },
        reactiveValue: {
            set(val) {
                this.$emit('input', val);
            },
            get() {
                return this.value;
            },
        },
    },
};
</script>

<style scoped></style>
